
import React, { Component } from 'react';
import DrawerMaterialUI from '@material-ui/core/Drawer';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import styled from "styled-components";

const StyledDrawer = styled(DrawerMaterialUI)`
  .MuiDrawer-paper {
    overflow-y: auto !important;
    
    @media (max-width: 767px) {
      width: 100% !important;
      max-width: 100vw;
    }
  }
  
  h2 {
    font-size: 24px;
    margin-bottom: 25px;
  }
  
  .body {
    padding: 20px 20px;
    
    @media (max-width: 767px) {
      width: auto !important;
      max-width: 100%;
      box-sizing: border-box;
      padding: 20px;
    }
  }
`;

const StyledBackdrop = styled(Backdrop)`
  position: absolute;
  z-index: 100;
`;


export class Drawer extends Component {

  static defaultProps = {
    anchor: 'right',
    loading: false,
    width: 'auto',
    disableEscapeKeyDown: false
  };

  render() {
    const { loading, width, disableEscapeKeyDown, ...otherProps } = this.props;
    return (
      <StyledDrawer
        ModalProps={{
          BackdropProps: {
            invisible: true
          },
          disableEscapeKeyDown: disableEscapeKeyDown
        }}
        {...otherProps}
      >
        {loading && (
          <StyledBackdrop open={loading} invisible={true}>
            <CircularProgress />
          </StyledBackdrop>
        )}
        <div className={'body'}
          style={{
            width: width
          }}
        >
          {this.props.children}
        </div>
      </StyledDrawer>
    )
  }
}
